import VehicleProperty from '../components/vehicleProperty/index.vue'
import OrderInfo from '../components/orderInfo/index.vue'
import BusinessAnalysis from '../components/businessAnalysis/index.vue'
import OperationCondition from '../components/operationCondition/index.vue'
import WithholdingFunds from '../components/withholdingFunds/index.vue'

// -----tab集合-----
export default function (judgePermission) {
  const allTabList = [
    { label: '车辆资产', name: 'VehicleProperty', component: VehicleProperty, permission: judgePermission('workbench_data_board_car') },
    { label: '订单信息', name: 'OrderInfo', component: OrderInfo, permission: judgePermission('workbench_data_board_order_info') },
    { label: '经营分析', name: 'BusinessAnalysis', component: BusinessAnalysis, permission: judgePermission('workbench_data_board_business_analysis') },
    { label: '运营情况', name: 'OperationCondition', component: OperationCondition, permission: judgePermission('workbench_data_board_operations') },
    { label: '资金回款', name: 'withholdingFunds', component: WithholdingFunds, permission: judgePermission('workbench_data_withholding_funds_dashboard') },
  ]
  return {
    allTabList,
  }
}
